var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "app-container-sitc",
      staticStyle: { "padding-bottom": "0px" },
    },
    [
      _c(
        "div",
        { staticClass: "filter-container-content" },
        [
          _c(
            "el-form",
            {
              ref: "searchFormRef",
              attrs: {
                model: _vm.searchForm,
                "label-position": "top",
                "label-width": "90px",
              },
            },
            [
              _c(
                "el-row",
                { attrs: { gutter: 14 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "form-item-bottom",
                          attrs: {
                            label: _vm.$t("booking.bookingJapan.POL") + ":",
                          },
                        },
                        [
                          _c("gl-port", {
                            model: {
                              value: _vm.searchForm.pol,
                              callback: function ($$v) {
                                _vm.$set(_vm.searchForm, "pol", $$v)
                              },
                              expression: "searchForm.pol",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "form-item-bottom",
                          attrs: {
                            label: _vm.$t("booking.bookingJapan.POD") + ":",
                          },
                        },
                        [
                          _c("gl-port", {
                            model: {
                              value: _vm.searchForm.pod,
                              callback: function ($$v) {
                                _vm.$set(_vm.searchForm, "pod", $$v)
                              },
                              expression: "searchForm.pod",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "form-item-bottom",
                          attrs: {
                            label:
                              _vm.$t("booking.bookingJapan.bookingStatus") +
                              ":",
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: { clearable: "" },
                              model: {
                                value: _vm.searchForm.status,
                                callback: function ($$v) {
                                  _vm.$set(_vm.searchForm, "status", $$v)
                                },
                                expression: "searchForm.status",
                              },
                            },
                            _vm._l(_vm.bookingList, function (item) {
                              return _c("el-option", {
                                key: item.codeValue,
                                attrs: {
                                  label: item.displayValue,
                                  value: item.codeValue,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { prop: "pot" } },
                        [
                          _c(
                            "el-radio",
                            {
                              attrs: { label: "1" },
                              on: { change: _vm.changeTime },
                              model: {
                                value: _vm.timeTypeRadio,
                                callback: function ($$v) {
                                  _vm.timeTypeRadio = $$v
                                },
                                expression: "timeTypeRadio",
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("booking.bookingJapan.POLETD"))
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-radio",
                            {
                              attrs: { label: "2" },
                              on: { change: _vm.changeTime },
                              model: {
                                value: _vm.timeTypeRadio,
                                callback: function ($$v) {
                                  _vm.timeTypeRadio = $$v
                                },
                                expression: "timeTypeRadio",
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("booking.bookingJapan.PODETA"))
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-radio",
                            {
                              attrs: { label: "3" },
                              on: { change: _vm.changeTime },
                              model: {
                                value: _vm.timeTypeRadio,
                                callback: function ($$v) {
                                  _vm.timeTypeRadio = $$v
                                },
                                expression: "timeTypeRadio",
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("booking.bookingJapan.CREATEDTIME")
                                )
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c("el-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              type: "daterange",
                              format: "yyyy-MM-dd",
                              "unlink-panels": true,
                              "range-separator": _vm.$t("home.form"),
                              "start-placeholder": _vm.$t("home.startTime"),
                              "end-placeholder": _vm.$t("home.endTime"),
                            },
                            on: { change: _vm.handleChangeTime },
                            model: {
                              value: _vm.dataTime,
                              callback: function ($$v) {
                                _vm.dataTime = $$v
                              },
                              expression: "dataTime",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                { attrs: { gutter: 14 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "form-item-bottom",
                          attrs: {
                            label: _vm.$t("booking.bookingJapan.BKGNO") + ":",
                          },
                        },
                        [
                          _c("el-input", {
                            model: {
                              value: _vm.searchForm.bkNo,
                              callback: function ($$v) {
                                _vm.$set(_vm.searchForm, "bkNo", $$v)
                              },
                              expression: "searchForm.bkNo",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "form-item-bottom",
                          attrs: {
                            label: _vm.$t("booking.bookingJapan.BLNO") + ":",
                          },
                        },
                        [
                          _c("el-input", {
                            model: {
                              value: _vm.searchForm.blNo,
                              callback: function ($$v) {
                                _vm.$set(_vm.searchForm, "blNo", $$v)
                              },
                              expression: "searchForm.blNo",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    {
                      staticStyle: { "text-align": "right" },
                      attrs: { span: 12 },
                    },
                    [
                      _c(
                        "div",
                        { staticStyle: { "margin-top": "28px" } },
                        [
                          _c(
                            "el-button",
                            {
                              staticClass: "btn-primary",
                              attrs: { type: "primary" },
                              on: {
                                click: function ($event) {
                                  return _vm.searchFormData()
                                },
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("booking.bookingJapan.searchButton")
                                ) + "\n            "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              staticClass: "btn-plain-primary",
                              on: {
                                click: function ($event) {
                                  return _vm.resetForm()
                                },
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("booking.bookingJapan.resetButton")
                                ) + "\n            "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              staticClass: "btn-primary",
                              attrs: { type: "primary" },
                              on: {
                                click: function ($event) {
                                  return _vm.exportFormData()
                                },
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("booking.bookingJapan.exportButton")
                                ) + "\n            "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "filter-container-content" }, [
        _c("div", [
          _c("div", { staticClass: "table-main-content" }, [
            _c("div", { staticClass: "table-title" }, [
              _vm._v(
                "\n            " +
                  _vm._s(_vm.$t("booking.bookingJapan.BookingHistory")) +
                  "\n          "
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticStyle: {
                  "margin-top": "10px",
                  "font-size": "14px",
                  color: "red",
                },
              },
              [
                _vm._v(
                  "\n            BKG NO. is temporary while the status is 'Waiting' or 'Pending', and it becomes confirmed once the status changes to 'Approved'.\n          "
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticStyle: { "margin-top": "10px" } },
              [
                _vm._v(
                  "\n            Total Amount JPY:" +
                    _vm._s(_vm.totalMoney) +
                    "\n            "
                ),
                _c(
                  "el-button",
                  {
                    staticClass: "btn-primary",
                    attrs: { type: "primary" },
                    on: { click: _vm.applyDownload },
                  },
                  [_vm._v("B/L Apply Form Download\n          ")]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "table-container-new" },
              [
                _c(
                  "hot-table",
                  {
                    key: _vm.tableKey,
                    ref: "hotTableCost",
                    attrs: {
                      "has-tip": "",
                      "data-source": _vm.tableCostData,
                      settings: _vm.hotSettings,
                      "current-page": _vm.listQuery.currentPage,
                      "page-size": _vm.listQuery.pageSize,
                      "selection-column-title": _vm.$t("table.No"),
                    },
                    on: { selectionChange: _vm.hotTableSelect },
                  },
                  _vm._l(_vm.sourceData, function (column, index) {
                    return _c(
                      "hot-column",
                      {
                        key: index,
                        attrs: { data: column.data, title: column.title },
                      },
                      [
                        column.isBookingHisJpBkNo
                          ? _c("booking-history-jp-bkNo", {
                              attrs: { "hot-renderer": "" },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        column.vessNameBtns
                          ? _c("vessel-name-buttons", {
                              attrs: { "hot-renderer": "" },
                              on: { handlePath: _vm.handlePath },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        column.isBookingHisJpBtns
                          ? _c("booking-hilstory-jp-buttons", {
                              attrs: { "hot-renderer": "" },
                              on: { handleToDetails: _vm.handleToDetails },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        column.isDateMonthEta
                          ? _c("booking-hilstory-date-month-eta", {
                              attrs: { "hot-renderer": "" },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        column.isDateMonthEtd
                          ? _c("booking-hilstory-date-month-etd", {
                              attrs: { "hot-renderer": "" },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        column.isDateMonthEtaPol
                          ? _c("booking-hilstory-date-month-eta-pol", {
                              attrs: { "hot-renderer": "" },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        column.isVoyageNoAndLeg
                          ? _c("booking-hilstory-jp-voyage-no-and-leg", {
                              attrs: { "hot-renderer": "" },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        column.isCopyItem
                          ? _c("booking-hilstory-jp-copy", {
                              attrs: { "hot-renderer": "" },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        column.hasFilterStatus
                          ? _c("filter-column", {
                              attrs: {
                                "hot-renderer": "",
                                filterList: column.filterList,
                                "filter-value": "codeValue",
                                "filter-label": "displayValue",
                              },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        column.hasFilter
                          ? _c("filter-column", {
                              attrs: {
                                "hot-renderer": "",
                                filterList: column.filterList,
                                "filter-value": "value",
                              },
                            })
                          : _vm._e(),
                      ],
                      1
                    )
                  }),
                  1
                ),
                _vm._v(" "),
                _c("pagination", {
                  staticClass: "pagePanel",
                  staticStyle: { "text-align": "left" },
                  attrs: {
                    total: _vm.listQuery.total,
                    page: _vm.listQuery.currentPage,
                    limit: _vm.listQuery.pageSize,
                  },
                  on: {
                    "update:page": function ($event) {
                      return _vm.$set(_vm.listQuery, "currentPage", $event)
                    },
                    "update:limit": function ($event) {
                      return _vm.$set(_vm.listQuery, "pageSize", $event)
                    },
                    pagination: _vm.searchFormData,
                  },
                }),
                _vm._v(" "),
                _c("div", { staticClass: "form-info-area" }, [
                  _c(
                    "div",
                    {
                      staticClass: "form-text",
                      staticStyle: {
                        position: "relative",
                        top: "50px",
                        left: "20px",
                      },
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.$t("booking.bookingJapan.historyInfo1")) +
                          "\n              "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "form-text",
                      staticStyle: {
                        position: "relative",
                        top: "60px",
                        left: "20px",
                      },
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.$t("booking.bookingJapan.historyInfo2")) +
                          "\n              "
                      ),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c("div", [
                  _c("i", {
                    staticClass: "el-icon-refresh-left",
                    on: { click: _vm.initData },
                  }),
                  _vm._v(" "),
                  _c("i", {
                    staticClass: "icon iconhuanyuan",
                    on: { click: _vm.handleSortOpen },
                  }),
                ]),
              ],
              1
            ),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("userCenter.billConsigneeApplication.editDialogText"),
            visible: _vm.editDialog,
            width: "30%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.editDialog = $event
            },
            close: _vm.closeDialog,
          },
        },
        [
          _c(
            "div",
            [
              _c(
                "el-row",
                [
                  _c(
                    "el-form",
                    {
                      ref: "billFormRef",
                      attrs: {
                        model: _vm.billForm,
                        rules: _vm.billRules,
                        "label-width": "100px",
                      },
                    },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "form-item-bottom",
                          attrs: {
                            label: _vm.$t(
                              "userCenter.editFormDialog.portFormItem"
                            ),
                            prop: "portCode",
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: { placeholder: "", clearable: "" },
                              model: {
                                value: _vm.billForm.portCode,
                                callback: function ($$v) {
                                  _vm.$set(_vm.billForm, "portCode", $$v)
                                },
                                expression: "billForm.portCode",
                              },
                            },
                            _vm._l(_vm.portOptions, function (item) {
                              return _c("el-option", {
                                key: item.value,
                                attrs: { label: item.label, value: item.value },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          staticClass: "form-item-bottom",
                          attrs: {
                            label: _vm.$t(
                              "userCenter.editFormDialog.operationFormItem"
                            ),
                            prop: "companyName",
                          },
                        },
                        [
                          _c("el-input", {
                            model: {
                              value: _vm.billForm.companyName,
                              callback: function ($$v) {
                                _vm.$set(_vm.billForm, "companyName", $$v)
                              },
                              expression: "billForm.companyName",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          staticClass: "form-item-bottom",
                          attrs: {
                            label: _vm.$t(
                              "userCenter.editFormDialog.operationFormItemCn"
                            ),
                            prop: "companyNameCn",
                          },
                        },
                        [
                          _c("el-input", {
                            model: {
                              value: _vm.billForm.companyNameCn,
                              callback: function ($$v) {
                                _vm.$set(_vm.billForm, "companyNameCn", $$v)
                              },
                              expression: "billForm.companyNameCn",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          staticClass: "form-item-bottom",
                          attrs: {
                            label: _vm.$t("userCenter.editFormDialog.USCI"),
                            prop: "usci",
                          },
                        },
                        [
                          _c("el-input", {
                            model: {
                              value: _vm.billForm.usci,
                              callback: function ($$v) {
                                _vm.$set(_vm.billForm, "usci", $$v)
                              },
                              expression: "billForm.usci",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "dialog-button-bottom" },
                [
                  _c(
                    "el-button",
                    {
                      staticStyle: { width: "70px" },
                      attrs: { size: "medium", type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.saveFormClick()
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(
                            _vm.$t("userCenter.editFormDialog.saveButton")
                          ) +
                          "\n          "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      staticStyle: { width: "70px" },
                      attrs: { size: "medium", type: "primary" },
                      on: {
                        click: function ($event) {
                          _vm.editDialog = false
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(
                            _vm.$t("userCenter.editFormDialog.cancelButton")
                          ) +
                          "\n          "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c("transfer", {
        ref: "transfer",
        attrs: {
          width: "40%",
          targetDataOne: _vm.targetDataOne,
          sourceDataOne: _vm.sourceData,
          visible: _vm.transferDialogVisible,
        },
        on: {
          "update:visible": function ($event) {
            _vm.transferDialogVisible = $event
          },
          handleSubimtSort: _vm.handleSubimtSort,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }